module.exports = __webpack_public_path__ + "static/media/ios_7_600.9523e572.png";